<div class="main-ho-abandonment-report">
  <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner *ngIf="isLoading"></mat-spinner>
  </div>
  <div class="handover-files">
    <div class="top">
        <h2>Adjunto del Informe de Abandono</h2>
        <div>
            <div *ngIf="abandonmentReportAttachment == null">
                0{{ "/" + fileLimit + " Archivos" }}
              </div>
              <div *ngIf="abandonmentReportAttachment != null">
                {{ abandonmentReportAttachment?.length + "/" + fileLimit + " Archivos" }}
              </div>
        </div>
        <ng-container *ngIf="abandonmentReportAttachment?.length < fileLimit">
            <input
              type="file"
              class="file-input"
              accept=".xls, .xlsx, .pdf"
              (change)="onFileSelected($event)"
              #fileUpload
              style="display: none"
            />
            <div class="attach" title="Documento">
              <button
                mat-button
                class = "upload-button"
                (click)="fileUpload.click()"
                [disabled]="readOnlyContent">
                <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
              </button><br/>
              <span>Archivos Excel, PDF </span>
            </div>
        </ng-container>
    </div>

    <div class="grid-attachment">
        <div class = "attachment" *ngFor="let f of abandonmentReportAttachment">
            <a
                class="attachment-link"
                href="{{dhoApiUrl}}/{{ f?.file_path }}"
                download="{{ f?.file_original_name }}"
                target="_blank"
            >
                {{ f?.file_original_name }}
            </a>
            <!-- Boton borrar-->
            <button
                *ngIf="!readOnlyContent"
                mat-button
                class="delete-button"
                (click)="deleteAbandonmentReportAttachment(f.file_id)"
                [disabled]="readOnlyContent"
            >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
        </div>
    </div>

  </div>
</div>
